import { createSelector } from 'reselect'

const getSelectionsState = state => state.selections

export const selectSelections = createSelector(
  getSelectionsState,
  state => state,
)

export const selectBrandCode = createSelector(
  selectSelections,
  state => state.brandCode,
)

export const selectShipCode = createSelector(
  selectSelections,
  state => state.shipCode,
)

export const selectDate = createSelector(selectSelections, state => state.date)

export const selectCurrency = createSelector(
  selectSelections,
  state => state.cur,
)
